import { PATIENT_SURVEY_API_URL } from '../../comm/config';
import { getUserInfo } from '../../utils';
import { AxiosInstance } from '../ehandover/axios';
import { rewriteOBJ } from '../commlogic';

const API_HOST = PATIENT_SURVEY_API_URL;

const POST_LIST = {
  getPatientSurveyList: '/patientSurvey/list',
  getPatientSurveyAllList: '/patientSurvey/allList',
  getPatientSurveyContact: '/patientSurvey/contact',
  genPatientQrCode: '/patientSurvey/qrcode',
  getPatientFilterList: '/patientSurvey/filterList',
  getPatientAllFilterList: '/patientSurvey/allFilterList',
  sharePatientSurvey: '/patientSurvey/share',
  getPatientSurveyDetail: '/patientSurvey/detail',
  getPatientSurveyBitrixTaskFrom: '/patientSurvey/bitrixTaskFrom',
  logPatientAppreciationAccess: '/patientSurvey/logPatientAppreciationAccess',
  getUnreadAppreciationCount: '/patientSurvey/getUnreadAppreciationCount',
  updateAppreciation: '/patientSurvey/updateAppreciation',
  getPatientSurveyConfig: '/patientSurvey/config'
};

const GET_LIST = {};

const PATIENT_SURVEY_API = {
  POST: POST_LIST,
  GET: GET_LIST,
};

rewriteOBJ(PATIENT_SURVEY_API, API_HOST);

const getPatientSurveyExport = (data) => {
  return AxiosInstance({
    method: 'post',
    url: `${API_HOST}/patientSurvey/export`,
    responseType: 'blob',
    data,
    headers: {
      'x-HospitalId': getUserInfo()?.hospId || '',
      isHideLoading: true,
    },
    timeout: 40 * 60 * 1000,
  });
};

export default { ...PATIENT_SURVEY_API.GET, ...PATIENT_SURVEY_API.POST, getPatientSurveyExport };
